import type { Category } from './types';
import { SubCategoryName } from './SubCategories';
import { MainCategoryName } from './MainCategories';
import { getSubCategoriesForMainCategory } from './MainCategoriesBySubCategories';

export function filterSubCategoriesBySelectedMainCategory(
    mainCategory?: MainCategoryName,
): SubCategoryName[] | [''] {
    return !mainCategory ? [''] : getSubCategoriesForMainCategory(mainCategory);
}

export function isKnownCategory(mainCategory: string): mainCategory is MainCategoryName {
    return !!MainCategoryName[mainCategory as keyof typeof MainCategoryName];
}

export function isKnownSubCategory(subCategory: string): subCategory is SubCategoryName {
    return !!SubCategoryName[subCategory as keyof typeof SubCategoryName];
}

export function filterUnknownCategories(categoriesArray: { mainCategory: string }[]): Category[] {
    return categoriesArray.filter((category): category is Category =>
        isKnownCategory(category.mainCategory),
    );
}
